export default "__VITE_ASSET__DiIbT$M___"